module.exports = __webpack_public_path__ + "img/cb9-r-r1.5d835fd7.gif";